'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduxOidc = require('redux-oidc');

var _Store = require('../services/Store');

var _Store2 = _interopRequireDefault(_Store);

var _OidcUserManager = require('../services/OidcUserManager');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates oidc user manager
 * @param {object} userManagerConfig 
 */
var initializeOidc = function initializeOidc(userManagerConfig) {
  var manager = (0, _reduxOidc.createUserManager)(userManagerConfig);

  (0, _reduxOidc.loadUser)((0, _Store2.default)(), manager);

  (0, _OidcUserManager.setUserManager)(manager);
};

exports.default = initializeOidc;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/services/OidcInitService.js
// module id = 816
// module chunks = 10